import {createCrud} from "./CRUD";

const initialState = { items: [], item: {} };

let {constants, actions, reducer} =
    createCrud(
        '/main/company-owner/',
        'CompanyOwner',
        'CompanyOwners',
        initialState);

export const companyOwnerConstants = constants;
export const companyOwnerActions = actions;
export const companyOwnerReducer = reducer;

